<template>
  <div class="container py-12 md:py-16 lg:py-20 xl:py-24">
    <AuthCard title="Admin Login">
      <form @keydown.enter.prevent="handleSubmit">
        <div class="flex flex-col gap-4">
          <CustumInput
            name="username"
            :defaultData="defaultData ? defaultData.email : null"
            label="User Name"
            placeholder="user name"
            :rules="{
              required: true,
              min: 3,
            }"
            :isTouched="isAllTouched"
            @setInput="setInput"
          />

          <CustumInputPassword
            name="password"
            :defaultData="defaultData ? defaultData.password : null"
            label="Password"
            placeholder="password ..."
            :rules="{
              required: true,
              min: 6,
            }"
            :isTouched="isAllTouched"
            @setInput="setInput"
          />
          <div class="hidden aflex items-center justify-between">
            <Checkbox>Remember Me</Checkbox>

            <router-link to="/forget-password">Forget password</router-link>
          </div>
        </div>
        <div class="flex items-center flex-wrap">
          <p>I'm<span class="text-red-600">*</span>:</p>
          <Select
            class="text-center min-w-[100%]"
            allowClear
            placeholder="Select who you are"
            @change="handleSelectBusiness"
          >
            <SelectOption v-for="admin in admins" :key="admin.alt" :value="admin.alt">{{
              admin.name
            }}</SelectOption>
          </Select>
          <CustumInput
            name="otp"
            label="OTP"
            v-if="showOTP"
            class="min-w-[100%]"
            placeholder="OTP"
            :rules="{
              required: true,
              min: 3,
            }"
            @setInput="setInput"
          />
        </div>

        <div class="mt-6">
          <Button
            type="primary"
            htmlType="submit"
            class="btn-gradient rounded"
            size="large"
            block
            :loading="isLoading"
            @click.prevent="handleSubmit"
            >Login</Button
          >

          <p class="hidden text-center mt-4 opacity-80">
            Don't have an account?
            <router-link to="/register">register</router-link>
          </p>
        </div>
      </form>
    </AuthCard>

    <Modal
      :visible="visible"
      :footer="null"
      :destroyOnClose="true"
      wrap-class-name="empty-modal"
      @ok="handleModalClose"
      @cancel="handleModalClose"
    >
      <AlertModal :warningMessage="warningMessage" @close="handleModalClose" />
    </Modal>
  </div>
</template>

<script>
import validation from '@/services/validation';
import { message, Checkbox, Button, Modal, Select, SelectOption } from 'ant-design-vue';
import CustumInput from '@/components/shared/form/CustumInput.vue';
import CustumInputPassword from '@/components/shared/form/CustumInputPassword.vue';
import adminauthApi from '@/services/apis/admin/adminauth.api';
import handleResErrors from '@/utils/handleResErrors';
import { saveAdminToken } from '@/services/jwt.service';
import AuthCard from './AuthCard.vue';
import AlertModal from './AlertModal.vue';
import { ADMIN_AUTH } from '../../../store/types';

export default {
  components: {
    AuthCard,
    CustumInput,
    CustumInputPassword,
    Checkbox,
    Button,
    AlertModal,
    Modal,
    Select,
    SelectOption,
  },
  props: {
    defaultData: Object,
  },
  data() {
    return {
      isAllTouched: false,
      isLoading: false,
      formData: {},
      visible: false,
      showOTP: false,
      warningMessage: '',
      admin: '',
      admins: [
        {
          name: 'Muhammed Ali',
          alt: 'muhammed',
        },
        {
          name: 'Dr Abdallah',
          alt: 'dr',
        },
        {
          name: 'Shahryar Monghasemi',
          alt: 'shahryar',
        },
        {
          name: 'Mahmoud Magdy',
          alt: 'mahmoud',
        },
      ],
    };
  },
  methods: {
    handleSelectBusiness(val) {
      this.admin = val;
    },
    handleModalClose() {
      this.visible = false;
      this.warningMessage = '';
    },
    setInput(vals) {
      console.log(vals);
      this.formData = { ...this.formData, ...vals };
    },
    async handleSubmit(e) {
      e.target.blur();

      this.isAllTouched = true;

      const validetionData = validation.validateAllData(this.formData);

      if (!validetionData.isValid) {
        return;
      }

      /// submit
      this.isLoading = true;
      try {
        const loginData = validetionData.data;
        loginData.send_otp_to = this.admin;
        const res = await adminauthApi.postLogin(loginData);

        if (res.user) {
          message.success('logged in successfully');
          console.log('TOKKEN', res.token);
          saveAdminToken(res.token);
          this.$store.commit(ADMIN_AUTH.SET_ADMIN_USER_DATA, res.user);
          this.$router.push('/admin');
        } else {
          // this.visible = true;
          // eslint-disable-next-line operator-linebreak
          this.warningMessage =
            'We are sorry, your account is not active yet. Please contact Commutrics Customer Service.';
          if (res.otp_required) {
            this.showOTP = true;
            message.success(res.message);
          } else {
            message.error('Something went wrong');
          }
        }

        this.isLoading = false;
      } catch (error) {
        message.error(handleResErrors(error));

        this.isLoading = false;
      }
    },
  },
};
</script>
